export default __webpack_public_path__ + "static/media/outputonlinepngtools.0b4e9943.png";